var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-layer-settings"},[_c(`${_vm.layerType}-settings`,{tag:"component",attrs:{"id":_vm.settingsId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }